export default function SectionHeading({
  eyebrow,
  title,
  align = "left",
  accent = "cyan",
  className = "",
}) {
  const accentColor =
    accent === "magenta"
      ? "#FF00FF"
      : accent === "lime"
        ? "#9FFF00"
        : accent === "orange"
          ? "#FF9900"
          : "#00FFFF";

  return (
    <div
      className={[
        align === "center" ? "text-center" : "text-left",
        className,
      ].join(" ")}
    >
      {eyebrow && (
        <div
          className={[
            "flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.4em]",
            align === "center" ? "justify-center" : "",
          ].join(" ")}
          style={{ color: accentColor }}
        >
          <span
            className="block h-px w-8"
            style={{ background: accentColor }}
          />
          <span>{eyebrow}</span>
          <span
            className="block h-px w-8"
            style={{ background: accentColor }}
          />
        </div>
      )}
      <h2 className="mt-4 font-display text-3xl font-black uppercase leading-[1.05] tracking-tight sm:text-5xl">
        <span
          className="gradient-text drop-shadow-[0_0_20px_rgba(255,0,255,0.35)]"
        >
          {title}
        </span>
      </h2>
    </div>
  );
}
